// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.code-input-container {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
}

.code-input-label {
  display: block;
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 12px;
  font-weight: 500;
}

.code-input {
  width: 100%;
  padding: 12px 16px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 8px;
  text-align: center;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  background: white;
  transition: all 0.2s ease;
  font-family: 'Courier New', Courier, monospace;
}

.code-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.code-input:disabled {
  background: #f3f4f6;
  cursor: not-allowed;
  opacity: 0.6;
}

.code-input-error {
  border-color: #ef4444;
}

.code-input-error:focus {
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.code-input-loading {
  border-color: #3b82f6;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.code-input-error-message {
  margin-top: 8px;
  font-size: 14px;
  color: #ef4444;
  font-weight: 500;
}

.code-input-hint {
  margin-top: 8px;
  font-size: 13px;
  color: #6b7280;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/styles/CodeInput.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".code-input-container {\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.code-input-label {\n  display: block;\n  font-size: 14px;\n  color: #6b7280;\n  margin-bottom: 12px;\n  font-weight: 500;\n}\n\n.code-input {\n  width: 100%;\n  padding: 12px 16px;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 8px;\n  text-align: center;\n  border: 2px solid #d1d5db;\n  border-radius: 8px;\n  background: white;\n  transition: all 0.2s ease;\n  font-family: 'Courier New', Courier, monospace;\n}\n\n.code-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.code-input:disabled {\n  background: #f3f4f6;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.code-input-error {\n  border-color: #ef4444;\n}\n\n.code-input-error:focus {\n  border-color: #dc2626;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.code-input-loading {\n  border-color: #3b82f6;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n.code-input-error-message {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #ef4444;\n  font-weight: 500;\n}\n\n.code-input-hint {\n  margin-top: 8px;\n  font-size: 13px;\n  color: #6b7280;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
